import { Fontisto } from '@expo/vector-icons';
import React from 'react';
import { Text, StyleProp, TextStyle, TouchableOpacity, ViewStyle, Pressable } from 'react-native';
import { FontInfo } from '../~Utilities/Constants';

interface IFeelingLucky
{
onPress? : () => void;
visible: boolean;

// getValue: () => boolean;

// bindEvent       : (onEvent    : (() => void), 
//                    bSubscribe : boolean) => void
}

/*   ====================================================================   */

export default class FeelingLucky extends React.Component<IFeelingLucky>
 {
   // private bDisabled : boolean = false;

   state = {
      visible:false
   }

   /*   ------------------------------------------------------------------   */

   constructor(props)
   {
   super(props);

   this.state = {visible:this.props.visible};

   this.Show       = this.Show.bind(this);
   this.Hide       = this.Hide.bind(this);
   // this.UpdateData = this.UpdateData.bind(this);
   }

   /*   ------------------------------------------------------------------   */

   Show()
   {
   this.setState({visible:true});
   }

   /*   ------------------------------------------------------------------   */

   Hide()
   {
   // this.bDisabled = true;
   if (this.state.visible == true)
      this.setState({visible:false});
   }

   /*   ------------------------------------------------------------------   */

   // componentDidMount() 
   // {
   // this.props.bindEvent(this.UpdateData, true);
   // }

   // /*   ------------------------------------------------------------------   */

   // componentWillUnmount() 
   // {
   // this.props.bindEvent(this.UpdateData, false);
   // }

   /*   ------------------------------------------------------------------   */

   // UpdateData()
   // {
   //  if (this.state.visible != this.props.getValue() &&
   //      this.state.visible == false                 &&
   //      this.bDisabled     == false)
   //      {
   //      this.setState({visible: true});
   //      }
   // }

   /*   ------------------------------------------------------------------   */

   render() 
   {
   if (!this.state.visible)
      return(null);
   return(
      <TouchableOpacity 

           //hitSlop={{top:0,left:0, bottom:-10, right:10}}
           style={{alignContent:'center',justifyContent:'center', minHeight:20, zIndex:100,
           borderRadius:5, alignSelf:'center',top:-8, minWidth:40, paddingBottom:4,
           position:'absolute',right:-2, backgroundColor:'transparent'}}
        onPress={this.props.onPress}
      >
      <Text style={[FontInfo.appStyles.txt_bold, {fontSize:FontInfo.iFontSize-2, 
                    letterSpacing:0, margin:2, paddingVertical:0, color:FontInfo.sYellow, }]}>Feeling lucky today?</Text>
      </TouchableOpacity>
      );
   }
}